import { render, staticRenderFns } from "./dialog-edit-location-curbside.vue?vue&type=template&id=6147f362&scoped=true&"
import script from "./dialog-edit-location-curbside.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-location-curbside.vue?vue&type=script&lang=js&"
import style0 from "./dialog-edit-location-curbside.vue?vue&type=style&index=0&id=6147f362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6147f362",
  null
  
)

export default component.exports